// extracted by mini-css-extract-plugin
module.exports = {"DialogClear":"DialogClear_DialogClear__0UhlI","description":"DialogClear_description___1Evo","title":"DialogClear_title__luijm"};